import thunk from "redux-thunk";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import scenarioGroupReducers from "../reducers/scenarioGroupReducers";
import scenarioManagerReducers from "../reducers/scenarioManagerReducers";
import testRunStatusReducer from "../reducers/testRunStatusReducer";
import scenarioTestDataReducers from "../reducers/scenarioTestTableReducers";
import dashboardReducers from "../reducers/scenarioCatalogue/dashboardReducers";
import viewReducers from "../reducers/scenarioCatalogue/viewReducers";
import addToCartReducers from "../reducers/addToCartReducers";
import filterReducers from "../reducers/scenarioCatalogue/filterReducers";
import addToCartReducersCloseLoop from "../reducers/closeLoop/addToCartReducersCloseLoop";
import CADaddToCartReducersCloseLoop from "../reducers/closeLoop/CADaddToCartReducersCloseLoop";
import scenarioGroupReducersCloseLoop from "../reducers/closeLoop/scenarioGroupReducersCloseLoop";
import baseScenarioCollectionReducersCloseLoop from "../reducers/closeLoop/baseScenarioCollectionReducersCloseLoop";
import scenarioTestDataReducersCloseLoop from "../reducers/closeLoop/scenarioTestTableReducersCloseLoop";
import testRunStatusReducerCloseLoop from "../reducers/closeLoop/testRunStatusReducerCloseLoop";
// import chartReducer from "../reducers/chartReducer";
import {
  loginReducer,
} from "../reducers/auth/authReducers";
import {loginInfo} from "../reducers/auth/loginInfo"
import scenarioFileUpload from "../reducers/scenarioFileUpload/uploadFile";
import scenarioFileUploadEnhanced from "../reducers/scenarioFileUpload/uploadFileEnhanced";
import cmScenarioFileUploadEnhanced from "../reducers/CM/cm_close_loop/cmScenarioFileUpload/uploadFileEnhanced"
 



import scenarioVariationUpload from "../reducers/scenarioVariationUpload/uploadFile";
import { bulkScenarioGroupReducer } from "../reducers/bulkScenarioGroup/scenarioGroupReducers";
import { scenarioInfoReducer } from "../reducers/bulkScenarioGroup/bulkScenarioInfoReducers";
import {
  fetchPerformanceDashboardDetails,
  fetchGPURAMMemoryUsage,
  fetchGPUAvailableRAMMemory,
  fetchCPUUtilization,
  fetchCPUAvailableRAMMemory,
  fetchCPURAMMemoryUsage,
} from "../reducers/closeLoop/performanceDashboard/performanceDashboardReducers";
import { dashboardFilterDataReducer } from "../reducers/closeLoop/kpiDashboard/dashboardReducers";
import {
  dashboardGraphReducer,
  longitudinalMotionKPIReducer,
  safeDrivingKPIReducer,
  egoVelocityKPIReducer,
  l1LateralAccelerationKPIReducer,
  l1LateralJerkKPIReducer,
  l1LongitudinalDecelerationKPIReducer,
  l1LongitudinalAccelerationKPIReducer,
  l1LongitudinalJerkKPIReducer,
  l1LongitudinalVelocityDropKPIReducer,
  l0CollisionCheckKPIReducer,
  l0lateralSafeDistanceKPIReducer,
  l0LongitudinalSafeDistanceKPIReducer,
  l0OffRoadCheckKPIReducer,
  l0LaneMarkingCheckKPIReducer,
  l0IndicatorCheckingKPIReducer,
  l0SpeedLimitCheckKPIReducer,
  l0FalseIndicatorCheckKPIReducer,
  rssLongitudinalSafeCheckKPIReducer,
  rssLateralLeftSafeCheckKPIReducer,
  rssLateralRightSafeCheckKPIReducer,
} from "../reducers/closeLoop/kpiDashboard/dashboardGraphs/dashboardGraphReducers";
import {
  downloadScenarioXOSCFile,
  downloadScenarioGroundTruthFile,
  fetchAvailableKPIReducer,
  downloadKPIFilesReducer,
} from "../reducers/closeLoop/kpiDashboard/download/downloadReportsReducers";
import scenarioSelectorCloseLoopReducer from "../reducers/closeLoop/scenarioSelectorReducersCloseLoop";
import customMapCloseLoopReducer from "../reducers/closeLoop/customMapReducersCloseLoop";
import adClientCloseLoopReducer from "../reducers/closeLoop/adClientReducersCloseLoop";
import testRunStatusRevisedReducer from "../reducers/closeLoop/testRunStatusRevisedReducerCloseLoop";

import { listResources } from './../reducers/closeLoop/apmDashboard/listResourcesReducer';
import { streamer } from './../reducers/closeLoop/apmDashboard/streamerReducer';
import { instanceReducer, availableInstanceReducer, getAllDockersReducer } from './../reducers/closeLoop/apmDashboard/instancesReducer';
import { deployedRegionsReducer } from './../reducers/closeLoop/apmDashboard/regions/regionsReducer';

import {
  topologyReducer,
  resourcesCreatedReducers,
  downloadTopologyFile,
} from "./../reducers/closeLoop/topology/index";
import {
  cmtopologyReducer,
  cmresourcesCreatedReducers,
  cmdownloadTopologyFile,
} from "./../reducers/CM/cm_close_loop/cm_CarMakerTopology/index";

import { axiosReducer } from "./../reducers/closeLoop/validation/index";
import ScenarioDetailsReducer from "../reducers/kpiDashboardReducer/ScenarioDetailsReducer";
import GoodScenarioReducer from "../reducers/kpiDashboardReducer/GoodScenarioReducer";
import NoGoodScenarioReducer from "../reducers/kpiDashboardReducer/NoGoodScenarioReducer";
// import KpiReportReducer from "../reducers/kpiDashboardReducer/KpiReportReducer";
import {fetchTopolgyData, fetchExecutionMetaData} from "../reducers/KpiSummaryDashboardEnhanced/SelectTopologyDropDownReducer";
import { KpiStatusReducer } from "../reducers/closeLoop/kpiDashboard/kpiEvaluationStatusReducer";
import KpiSummaryMainReducers from "../reducers/KpiSummaryDashboardEnhanced/kpiSummaryMainReducers";
import KpiSummaryLevelOneReducers from "../reducers/KpiSummaryDashboardEnhanced/KpiSummaryLevelOneReducers";
import KpiSummaryLevelThreeReducers from "../reducers/KpiSummaryDashboardEnhanced/KpiSummaryLevelThreeReducers";
import KpiSummaryScenarioTablesReducers from "../reducers/KpiSummaryDashboardEnhanced/kpiSummaryScenarioTablesReducers";
import KpiSummaryScenarioAdvanceSearchModalReducers from "../reducers/KpiSummaryDashboardEnhanced/kpiSummaryScenarioAdvanceSearchModalReducers";
import ExpandableKpiSummaryComponentReducers from "../reducers/KpiSummaryDashboardEnhanced/ExpandableKpiSummaryComponentReducers";
import {
  dropDownSimulatorReducer,
  dropDownModelReducer,
  dropDownModelVersionReducer,
  dropDownFeatureReducer,
  dropDownBaseScenarioReducer,
  dropDownSubmitReducer,
  baseScenarioSelectedReducer,
  dropDownSituation2Reducer,
  dropDownSubmitCarMakerReducer,
  
} from "../reducers/closeLoop/scenarioCollection/dropDownModalReducers";

import {addToCartScenarioCollectionReducers,
        selectedScenarioUuidList,
        selectedScenarioNameList,
        addVariationToGroupReducers,
        addBulkScenariosToListReducers,
        bulkVariationCartCountReducer,
        currentPageNumberReducer } from '../reducers/closeLoop/scenarioCollection/addToCartScenarioCollectionReducers'
import {inputFileUploadProgress,
        bulkInputFilesUploadStatus,
        extractImagesAndDescription,
        // uploadBulkScenarioFiles
      } from "./../reducers/scenarioFileUpload/uploadBulkFiles"
import {masterInputFileUploadProgress, masterInputFilesUploadStatus} from "./../reducers/scenarioVariationUpload/uploadInputFile"
import {selectAllScenarioGroupInfoReducer} from '../reducers/closeLoop/scenarioGroup/closeLoopScenarioGroupReducers'
import {scenarioVariationInfoReducer} from '../reducers/closeLoop/scenarioGroup/expandableScenarioComponentReducers'
import {selectCarMakerAllScenarioGroupInfoReducer} from '../reducers/CM/cm_close_loop/cm_CarMakerScerioGroup/closeLoopScenarioGroupReducers'

import {scenarioCarMakerVariationInfoReducer, scenarioCarMakerVersionInfoReducer} from '../reducers/CM/cm_close_loop/cm_CarMakerScerioGroup/expandableScenarioComponentReducers'
import {dropDownSubmitCarMakerFusionReducer} from '../reducers/CM/cm_open_loop/fusiondataCollection/dropDownModalReducers'

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function configureStore() {
    const store = createStore(
        combineReducers({
            scenarioGroup: scenarioGroupReducers,
            scenarioCatalogue: scenarioManagerReducers,
            testRunStatus: testRunStatusReducer,
            scenarioTestData: scenarioTestDataReducers,
            toggleState: dashboardReducers,
            viewScenarioCatalogueData: viewReducers,
            cartItems: addToCartReducers,
            filters: filterReducers,
            close_loop_cart: addToCartReducersCloseLoop,
            CAD_close_loop_cart: CADaddToCartReducersCloseLoop,
            close_loop_scenarioGroup: scenarioGroupReducersCloseLoop,
            close_loop_baseScenarioCollection: baseScenarioCollectionReducersCloseLoop,
            scenarioTestData_close_loop: scenarioTestDataReducersCloseLoop,
            testRunStatus_close_loop: testRunStatusReducerCloseLoop,
            // chartData: chartReducer,
            uploadFile: scenarioFileUpload,
            bulkScenarioGroup: bulkScenarioGroupReducer,
            scenarioInformation: scenarioInfoReducer,
            uploadVariations: scenarioVariationUpload,
            gpuUtilize: fetchPerformanceDashboardDetails,
            gpuRAMUsage: fetchGPURAMMemoryUsage,
            gpuAvailRAM: fetchGPUAvailableRAMMemory,
            cpuUtilize: fetchCPUUtilization,
            cpuAvailRam: fetchCPUAvailableRAMMemory,
            cpuRAMUsage: fetchCPURAMMemoryUsage,
            dashboardFilterData: dashboardFilterDataReducer,
            dashboardGraphData: dashboardGraphReducer,
            longitudinalMotion: longitudinalMotionKPIReducer,
            safeDriving: safeDrivingKPIReducer,
            egoVelocity: egoVelocityKPIReducer,
            individualDashboardReports: downloadScenarioXOSCFile,
            l1LateralAcceleration: l1LateralAccelerationKPIReducer,
            l1LateralJerk: l1LateralJerkKPIReducer,
            l1LongitudinalDeceleration: l1LongitudinalDecelerationKPIReducer,
            l1LongitudinalAcceleration: l1LongitudinalAccelerationKPIReducer,
            l1LongitudinalJerk: l1LongitudinalJerkKPIReducer,
            l1LongitudinalVelocityDrop: l1LongitudinalVelocityDropKPIReducer,
            l0CollisionCheck: l0CollisionCheckKPIReducer,
            l0lateralSafeDistance: l0lateralSafeDistanceKPIReducer,
            l0LongitudinalSafeDistance: l0LongitudinalSafeDistanceKPIReducer,
            l0OffRoadCheck: l0OffRoadCheckKPIReducer,
            l0LaneMarkingCheck: l0LaneMarkingCheckKPIReducer,
            l0IndicatorChecking: l0IndicatorCheckingKPIReducer,
            l0SpeedLimitCheck: l0SpeedLimitCheckKPIReducer,
            l0FalseIndicatorCheck: l0FalseIndicatorCheckKPIReducer,
            rssLongitudinalSafeCheck: rssLongitudinalSafeCheckKPIReducer,
            rssLateralLeftSafeCheck: rssLateralLeftSafeCheckKPIReducer,
            rssLateralRightSafeCheck: rssLateralRightSafeCheckKPIReducer,
            scenarioSelectorCloseLoop: scenarioSelectorCloseLoopReducer,
            testRunStatusRevisedCloseLoop: testRunStatusRevisedReducer,
            individualGroundTruthReports: downloadScenarioGroundTruthFile,
            customMapCloseLoop: customMapCloseLoopReducer,
            adClientCloseLoop: adClientCloseLoopReducer,
            availableKPIList: fetchAvailableKPIReducer,
            downloadKPIFiles: downloadKPIFilesReducer,

            // User Information
            loginUser: loginReducer,

            // APM Dashboard
            resources: listResources,
            streams: streamer,
            instances: instanceReducer,
            deployedRegions: deployedRegionsReducer,
            // Restructured APM Dashboard.
            availableInstances: availableInstanceReducer,
            availableDockers: getAllDockersReducer,

            // Validation Checks & Configuration.
            axios: axiosReducer,

            KpiStatusReducer: KpiStatusReducer,

            ScenarioDetailsReducer: ScenarioDetailsReducer,
            GoodScenarioReducer: GoodScenarioReducer,
            NoGoodScenarioReducer: NoGoodScenarioReducer,
            // KpiReportReducer: KpiReportReducer,

            topologyListData: KpiSummaryMainReducers,
            topologyData: fetchTopolgyData,
            executionMetaData: fetchExecutionMetaData,
            KpiSummaryLevelOneData: KpiSummaryLevelOneReducers,

            // Topology Handler
            topology: topologyReducer,
            resourcesToBeCreated: resourcesCreatedReducers,
            downloadTopologySchema: downloadTopologyFile,

          // cm topology Handler
             cm_topology:  cmtopologyReducer,
             cm_resourcesToBeCreated:cmresourcesCreatedReducers,
             cm_downloadTopologySchema:cmdownloadTopologyFile,





            KpiSummaryLevelThreeData: KpiSummaryLevelThreeReducers,
            KpiSummaryScenarioTablesData: KpiSummaryScenarioTablesReducers,
            KpiSummaryScenarioFilterData: KpiSummaryScenarioAdvanceSearchModalReducers,
            ExpandableKpiSummaryComponentData: ExpandableKpiSummaryComponentReducers,
            
            DropDownSimulatorData: dropDownSimulatorReducer,
            DropDownModelData: dropDownModelReducer,
            DropDownModelVersionData: dropDownModelVersionReducer,
            DropDownFeatureReducer: dropDownFeatureReducer,
            DropDownBaseScenarioReducer: dropDownBaseScenarioReducer,
            DropDownSubmitReducer: dropDownSubmitReducer,
            BaseScenarioSelectedReducer: baseScenarioSelectedReducer,
            uploadFileEnhanced: scenarioFileUploadEnhanced,
            bulkInputFileUpload: inputFileUploadProgress,
            bulkInputFilesUploadStatusReducer: bulkInputFilesUploadStatus,
            extractImagesAndDescriptionReducer: extractImagesAndDescription,
            // uploadBulkScenarioFilesReducer: uploadBulkScenarioFiles,
            uploadMasterInputFilesReducer: masterInputFileUploadProgress,
            masterInputFilesUploadStatusReducer: masterInputFilesUploadStatus,
            
            addToCartScenarioCollectionData: addToCartScenarioCollectionReducers,
            selectedScenarioUuidListData: selectedScenarioUuidList,
            selectedScenarioNameListData: selectedScenarioNameList,
            addVariationToGroupStatus: addVariationToGroupReducers,
            addBulkScenariosToListStatus: addBulkScenariosToListReducers,
            bulkVariationCartCountReducerStatus: bulkVariationCartCountReducer,
            currentPageNumberData: currentPageNumberReducer,
            DropDownSubmitCarMakerReducer:dropDownSubmitCarMakerReducer,
            DropDownSubmitCarMakerFusionReducer :dropDownSubmitCarMakerFusionReducer,
            selectAllScenarioGroupInfo: selectAllScenarioGroupInfoReducer,
            scenarioVariationInfo: scenarioVariationInfoReducer,

            cmUploadFileEnhanced: cmScenarioFileUploadEnhanced,
            selectCarMakerAllScenarioGroupInfo:selectCarMakerAllScenarioGroupInfoReducer,
            scenarioCarMakerVariationInfo:scenarioCarMakerVariationInfoReducer,
            scenarioCarMakerVersionInfo:scenarioCarMakerVersionInfoReducer,
            loginInfo:loginInfo
        }),
        composeEnhancer(applyMiddleware(thunk))
    );

  return store;
}

export default configureStore;